define('app-ConciergeTP/main',['./settings'], function (settings) {

    if ($('#conciergeContainer').length == 0) {
        return null;
    } else {
        return {

            toggleHiddenContent: function (elementTocheck, elementToShow) {
                elementTocheck.length > 0 && elementTocheck.prop('checked') ? elementToShow.removeClass('hidden') : elementToShow.addClass('hidden');
            },

            validateCruisePage: function (event) {
                if ($(settings.fixedDiningInput).prop('checked')) {
                    if ($(settings.tableSizeInput) !== undefined && $(settings.tableSizeInput).val() === "0") {
                        $(settings.tableSizeValidationMessage).removeClass('hidden')
                        event.preventDefault();
                    } else {
                        $(settings.tableSizeValidationMessage).addClass('hidden')
                    }
                }

                if ($(settings.giftContentContainer) !== undefined) {
                    var invalidItems = 0;

                    if ($(settings.giftcheckbox).prop('checked')) {
                        var selectedItems = $(settings.shoppingQuantityInputs).filter(function () {
                            return $(this).val() > 0;
                        });

                        if (selectedItems.length === 0) {
                            $(settings.selectGiftItemsValidationMessage).removeClass('hidden');
                            invalidItems++;
                        } else {
                            if ($(settings.selectGiftItemsValidationMessage).is(':visible'))
                            {
                                $(settings.selectGiftItemsValidationMessage).addClass('hidden');
                            }

                            var providedContacts = $('input.contact-value').filter(function() {
                                return $(this).val().length > 0;
                            });

                            if (providedContacts.length === 0) {
                                event.preventDefault();
                                $(settings.contactValueValidationMessages).addClass('hidden');
                                $(settings.selectContactMethodValidationMessage).removeClass('hidden');
                                invalidItems++;
                            }
                        }
                    }

                    if (invalidItems > 0) {
                        event.preventDefault();
                        $(settings.contactValidationMessagesContainer).removeClass('hidden');
                    } else {
                        $(settings.contactValidationMessagesContainer).addClass('hidden');
                    }
                }

            },

            hideAllGiftAndContactValidation: function () {
                $('#contactValidationMessagesContainer').addClass('hidden').children('li').addClass('hidden');
            },

            run: function () {
                var thisModule = this;

                var giftContainer = $(settings.giftContentContainer),
                    isGift = $(settings.giftcheckbox),
                    giftMessage = $(settings.giftMessage),
                    tableSizeContainer = $(settings.tableSizeContainer),
                    shoppingItemContainer = $(settings.shoppingItemContainer),
                    shoppingQuantityInputs = $(settings.shoppingQuantityInputs)
                    diningOptions = $(settings.diningOptions),
                    contactOptionInputs = $(settings.contactOptionInputs),
                    upgradeCheckbox = $(settings.upgradeCheckbox),
                    upgradeContentContainer = $(settings.upgradeContentContainer),
                    contactContainer = $(settings.contactContainer),
                    selectContactMethodValidationMessage = $(settings.selectContactMethodValidationMessage),
                    contactValidationMessagesContainer = $(settings.contactValidationMessagesContainer),
                    contactValueValidationMessages = $(settings.contactValueValidationMessages),
                    runningTotal = $(settings.runningtotal),
                    giftSelectionValidationMessage = $(settings.giftSelectionValidationMessage),
                    isSagaOceanCruise = $(settings.isOceanCruise);

                //Accordion behaviour
                $(settings.tabs + ' ' + settings.tabLink).click(function (event) {
                    event.preventDefault();
                    var associatedTab = $('#' + $(event.target).attr('rel'));
                    var modelPropName = associatedTab.data("model-prop-name");
                    var parent = associatedTab.parent('.accordion-group');
                    if (associatedTab.is(':visible')) {
                        associatedTab.slideUp('1000');
                        associatedTab.attr('aria-hidden', 'aria-hidden');
                        parent.removeClass('active');
                        $('#' + modelPropName).val('false');
                    }
                    else {
                        $(associatedTab).slideDown('1000', function () {
                            associatedTab.removeAttr('aria-hidden');
                            parent.addClass('active');
                            $('#' + modelPropName).val('true');
                        });
                    }
                });

                if (giftContainer !== undefined) {
                    isGift.on('change', function () {
                        if (!giftContainer.prop('checked')) {
                            thisModule.hideAllGiftAndContactValidation();
                        }
                        thisModule.toggleHiddenContent(isGift, giftMessage);
                        thisModule.toggleHiddenContent(isGift, contactContainer);
                    });

                }

                $(settings.diningOptionsContainer).on('change', 'input[type=radio]', function (event) {
                    var target = $(event.target);
                    target.attr("id") == "FixedDining" ? tableSizeContainer.removeClass("hidden") : tableSizeContainer.addClass("hidden");
                    diningOptions.toggleClass('selected');
                });

                $(settings.diningOptionsContainer).on('change', 'select', function (event) {
                    var target = $(event.target);
                    if ($(settings.fixedDiningInput).prop('checked') && target.val() !== "") {
                        $(settings.tableSizeValidationMessage).addClass('hidden');
                    }
                });

                if (shoppingItemContainer !== undefined && shoppingQuantityInputs !== undefined) {
                    shoppingQuantityInputs.on('change', function () {
                        if (!giftSelectionValidationMessage.hasClass('hidden')) {
                            giftSelectionValidationMessage.addClass('hidden');
                            if (contactValueValidationMessages.filter(':visible').length === 0) {
                                contactValidationMessagesContainer.addClass('hidden');
                            }
                        }
                        var total = 0;
                        for (var i = 0; i < shoppingQuantityInputs.length; i++) {
                            total += shoppingQuantityInputs[i].value * shoppingQuantityInputs[i].dataset.price;
                        }
                        runningTotal.empty().text(parseFloat(total).toFixed(2));
                    });
                }

                if (upgradeCheckbox !== undefined) {
                    upgradeCheckbox.on('change', function () {
                        upgradeContentContainer.toggleClass("hidden");
                    });
                }

                settings.submit.on("click", function (event) {
                    if (isSagaOceanCruise.val().toLowerCase() === "true") {
                        thisModule.validateCruisePage(event);
                    }
                });
            }
        }
    }
});
